import * as Yup from "yup";

/**
 * Validation Schema for FundingSource details
 */
export const fundingSourceSchema = Yup.object().shape({
  status: Yup.string().required("Required").oneOf(["VERIFIED", "VERIFYING", "WAITING_FOR_CUSTOMER_ACTION"]),
});
